import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import VueMaterialIcon from 'vue-material-icon';

import Inicio from '@/views/Inicio.vue';

Vue.component(VueMaterialIcon.name, VueMaterialIcon)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  Inicio,
  render: function (h) { return h(App) }
}).$mount('#app')
